module.exports = __webpack_public_path__ + "img/step3-mobile-en.489f338c.webp";